"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMarker = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const list_marker_styles_1 = require("@/components/indicators/list-marker/list-marker.styles");
let ListMarker = class ListMarker extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'number';
        this.value = 1;
    }
    render() {
        if (this.variant === 'check')
            return this.renderCheck();
        return (0, lit_1.html) `
      ${this.value}
    `;
    }
    renderCheck() {
        return (0, lit_1.svg) `
      <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.5 5L4 7.5L8.5 2.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;
    }
};
ListMarker.styles = list_marker_styles_1.listMarkerStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ListMarker.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], ListMarker.prototype, "value", void 0);
ListMarker = __decorate([
    (0, decorators_js_1.customElement)('mm-list-marker')
], ListMarker);
exports.ListMarker = ListMarker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC1tYXJrZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJsaXN0LW1hcmtlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBRTNELCtGQUF5RjtBQUtsRixJQUFNLFVBQVUsR0FBaEIsTUFBTSxVQUFXLFNBQVEsZ0JBQVU7SUFBbkM7O1FBRXVCLFlBQU8sR0FBc0IsUUFBUSxDQUFBO1FBQ3JDLFVBQUssR0FBRyxDQUFDLENBQUE7SUFzQnZDLENBQUM7SUFwQkMsTUFBTTtRQUNKLElBQUksSUFBSSxDQUFDLE9BQU8sS0FBSyxPQUFPO1lBQUUsT0FBTyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7UUFDdkQsT0FBTyxJQUFBLFVBQUksRUFBQTtRQUNQLElBQUksQ0FBQyxLQUFLO0tBQ2IsQ0FBQTtJQUNILENBQUM7SUFFTyxXQUFXO1FBQ2pCLE9BQU8sSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7S0FVVCxDQUFBO0lBQ0gsQ0FBQzs7QUF2Qk0saUJBQU0sR0FBRyxxQ0FBZ0IsQ0FBQTtBQUNKO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsyQ0FBc0M7QUFDckM7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3lDQUFVO0FBSDFCLFVBQVU7SUFEdEIsSUFBQSw2QkFBYSxFQUFDLGdCQUFnQixDQUFDO0dBQ25CLFVBQVUsQ0F5QnRCO0FBekJZLGdDQUFVIn0=